import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateWidgetCollapseState as UpdateWidgetCollapseStateMutation,
    UpdateWidgetCollapseStateVariables,
    WidgetUpdateCollapseStateInput,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../../apollo-client';

import WIDGET_COLLAPSED_FRAGMENT from '../fragments/widget-collapsed-fragment.graphql';
import UPDATE_WIDGET_COLLAPSE_STATE from '../mutations/update-widget-collapse-state.graphql';

export const useUpdateWidgetCollapseState = (): {
    updateWidgetCollapseState: (arg1: WidgetUpdateCollapseStateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateWidgetCollapseState, {loading, error}] = useMutation<
        UpdateWidgetCollapseStateMutation,
        UpdateWidgetCollapseStateVariables
    >(UPDATE_WIDGET_COLLAPSE_STATE);

    return {
        updateWidgetCollapseState: (input: WidgetUpdateCollapseStateInput) =>
            updateWidgetCollapseState({
                variables: {input},
                // @ts-expect-error
                optimisticResponse: () => {
                    const widgetFragment = nutApolloClient.readFragment({
                        id: input.widget,
                        fragmentName: 'WidgetCollapsedFragment',
                        fragment: WIDGET_COLLAPSED_FRAGMENT,
                    });

                    if (widgetFragment) {
                        return {
                            widgetUpdateCollapseState: {
                                __typename: 'WidgetUpdateCollapseStatePayload',
                                widget: {
                                    ...widgetFragment,
                                    isCollapsedForUser: input.isCollapsed,
                                },
                            },
                        };
                    }

                    return {};
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
